export default "__VITE_ASSET__f47bc62f__"